// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2YnJL","calendarButtons":"ClockData_calendarButtons__25-V8"};